<template>
  <div class="d-flex align-center flex-row px-6 py-4">
    <v-icon class="pa-0 ml-0 mr-2 text-secondary">
      ico-sm-light-tip-line
    </v-icon>
    <span class="text-body-2 text-secondary">{{ t('autocomplete.empty-recent-searches') }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { useI18n } from '@src/composables/useI18n'

export default defineComponent({
  name: 'EmtpyRecentSearches',
  setup() {
    const { t } = useI18n()
    return { t }
  }
})

</script>
